import { uniqueId } from 'lodash';

import {
  Transaction,
  TransactionAttributes,
  TransactionRelationships,
} from 'dashboard/models/transaction';
import { FieldType } from 'lib/fields';
import { ApiModel } from 'lib/interfaces/api';

export const generateTransactionId = () => uniqueId('txn_');

export function createPreviewTransaction(
  attributes?: Partial<TransactionAttributes>,
  relationships?: Partial<TransactionRelationships>,
  id?: string,
): Transaction {
  return {
    id: id || generateTransactionId(),
    type: ApiModel.Transaction,
    attributes: {
      'created-at': '2019-10-19T06:31:58.000Z',
      'updated-at': '2019-10-19T09:31:58.000Z',
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      'redacted-at': null,
      'reference-id': 'sw:ep_1',
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      'external-id': null,
      fields: {
        alert_name: {
          type: FieldType.String,
          value: 'Deposits over 1000',
        },
        total: {
          type: FieldType.Number,
          value: 1001,
        },
        is_deposit: {
          type: FieldType.Boolean,
          value: true,
        },
        flagged: {
          type: FieldType.Boolean,
          value: true,
        },
      },
      ...attributes,
    },
    relationships: {
      cases: {
        data: [],
      },
      environment: {
        data: {
          id: 'environment_id',
          type: ApiModel.EnvironmentProduction,
        },
      },
      'related-accounts': {
        data: [],
      },
      'related-cases': {
        data: [],
      },
      'related-inquiries': {
        data: [],
      },
      'related-reports': {
        data: [],
      },
      'related-transactions': {
        data: [],
      },
      'related-verifications': {
        data: [],
      },
      'related-verification-documents': {
        data: [],
      },
      tags: {
        data: [],
      },
      'transaction-label': {
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        data: null,
      },
      'transaction-type': {
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        data: null,
      },
      'transaction-status': {
        data: null,
      },
      ...relationships,
    },
  };
}
